import styled from "styled-components";
import {
    Text,
    Flex,
    useModal,
    CalculateIcon,
    Skeleton,
    FlexProps,
    Button,
} from "@pancakeswap/uikit";
import Balance from "../../../components/Balance";
import BigNumber from "bignumber.js";
import { BIG_ZERO } from "utils/bigNumber";
import React from "react";
import { setIdx } from "store/IndexSlice";
import { useDispatch } from "react-redux";
import { useLocation } from 'react-router-dom'
import { Box } from "@mui/material";

const AprLabelContainer = styled(Flex)`
  &:hover {
    opacity: 0.5;
  }
  
`;

interface AprProps extends FlexProps {
    pool: any;
    index: any
    stakedBalance: any;
    showIcon: boolean;
    performanceFee?: number;
}

const Apr: React.FC<AprProps> = ({
    pool,
    index,
    showIcon,
    stakedBalance,
    performanceFee = 0,
    ...props
}) => {
    const {
        stakingToken,
        earningToken,
        isFinished,
        earningTokenPrice,
        stakingTokenPrice,
        userData,
        apr,
        rawApr,
        vaultKey,
    } = pool;

    const stakingTokenBalance = userData?.stakingTokenBalance
        ? new BigNumber(userData.stakingTokenBalance)
        : BIG_ZERO;


    const [RoiCalculatoropen, setRoiCalculatorOpen] = React.useState(false);
    const dispatch = useDispatch()
    const RoiCalculator = () => dispatch(setIdx(index));

    const handleClose = () => dispatch(setIdx(index));
    // const location = useLocation();
    return (

        <>
            <AprLabelContainer
                alignItems="center"
                justifyContent="flex-start"
                {...props}
            >
                <Balance
                    onClick={(e) => {
                        e.stopPropagation();
                        RoiCalculator()
                    }}
                    color="white"
                    lineHeight="1"
                    display="inline"
                    fontSize="16px"
                    decimals={2}
                    prefix=""
                    value={pool.apy}
                    unit="%"
                />
                <Box sx={{ display: { xs: 'none', sm: 'none', md: 'flex' } }}>
                    <Button
                        onClick={(e) => {
                            e.stopPropagation();
                            RoiCalculator()
                        }}
                        variant="text"
                        width="20px"
                        height="20px"
                        padding="0px"
                        marginLeft="4px"
                    >
                        <CalculateIcon color="#00FED9" width="20px" />
                    </Button>
                </Box>

                {/* <Text>-</Text> */}
            </AprLabelContainer>


        </>
    )
}

export default Apr;
